import App from './App.vue';
import Vue from 'vue';

export default (options) => {
    // все опции доступны везде как this.$appOptions (просто options зарезервировано)
    Vue.prototype.$appOptions = options;
    Vue.prototype.$dataset = options.wrapper.dataset;

    const vueApp = new Vue({
        render: (h) => {
            return h(App);
        }
    });

    vueApp.$mount(options.id);
};
